<template>
    <div>
        <h4 class="mb-1">Want to work with me?</h4>
        <p class="mt-0">Your project matters. Because we matter.</p>
        <form>
            <base-input class="mt-5"
                        alternative
                        placeholder="Your name"
                        addon-left-icon="ni ni-single-02"
                        v-model.lazy="name">
            </base-input>
            <base-alert v-if="error.name" type="danger">
                {{error.name}}
            </base-alert>
            <base-input alternative
                        placeholder="Email address"
                        addon-left-icon="ni ni-email-83"
                        v-model.lazy="email">
            </base-input>
            <base-alert v-if="error.email" type="danger">
                {{error.email}}
            </base-alert>
            <base-input class="mb-4">
                    <textarea class="form-control form-control-alternative" name="name" rows="4"
                            cols="80" placeholder="Type a message..."
                            v-model.lazy="message"></textarea>
            </base-input>
            <base-alert v-if="error.message" type="danger">
                {{error.message}}
            </base-alert>
            <base-button @click="handleSubmit" type="default" round block size="lg">
                Send
            </base-button>
            <base-alert v-if="error.other" type="danger">
                {{error.other}}
            </base-alert>
            <p class="mt-3 mb-0">
            This site is protected by reCAPTCHA and the Google
            <a class="text-warning" href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a class="text-warning" href="https://policies.google.com/terms">Terms of Service</a> apply.
            </p>
        </form>
    </div>
</template>

<script>
import * as validator from "email-validator"
import BaseAlert from '../../../components/BaseAlert.vue';

export default {
  components: { BaseAlert },
    methods: {
        handleSubmit(e) {
            e.preventDefault();

            this.error = {}

            // Verify input
            if (!validator.validate(this.email)) {
                this.error.email = 'Please ensure your email address is valid'
            }

            if (this.message === "") {
                this.error.message = 'Please enter a message'
            }

            if (this.name === "") {
                this.error.name = 'Please enter your name'
            }

            if (Object.keys(this.error).length !== 0) {
                return;
            }

            grecaptcha.ready(() => {
                grecaptcha.execute('6LfNqlQhAAAAAOlniHKxMWqEloaEf0grYErrF8-7', {action: 'submit'}).then((token) => {
                    
                    this.axios.post(process.env.VUE_APP_API_URL+'/verify', {
                        recaptchaToken: token,
                        from: {
                            name: this.name,
                            email: this.email,
                        },
                        message: this.message
                    }).then(response => {
                        var status = response.data
                        console.log(response);
                        if (status.success) {
                            this.$emit("success");
                        } else {
                            this.error.other = {status: response.status, status};
                        }
                    }).catch(error => {
                        console.log(error.message);
                    });
                })
            })
        }
        
    },
    data() {
        return {
            name: "",
            email: "",
            message: "",
            error: {}
            
        }
    }
}
</script>
